function setupShareLinks(selector='.js-share-link')
{
    Array.from(document.querySelectorAll(selector)).forEach(shareLink => {
        shareLink.addEventListener('click', e =>
		{
			e.preventDefault();

			const
				w = 540,
				h = 400,
				left = (screen.width/2)-(w/2),
  				top = (screen.height/2)-(h/2);

			window.open(e.currentTarget.href, 'Delen', `width=${w},height=${h},left=${left},top=${top}`);
		});
    });
}
export default setupShareLinks;
